export default __webpack_public_path__ + "aa7f6fe00417449348834cca407be472.svg";